const normalizeUpper = (value) =>
  typeof value === "string" ? value.toUpperCase() : "";

const hasEmptyInvoiceSerial = (value) =>
  value === null || value === undefined || value === "";

const normalizeNumber = (value) => {
  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) ? parsedValue : null;
};

export const isSubscriptionDebitLedger = (entry = {}) =>
  normalizeUpper(entry?.type) === "DEBIT" &&
  normalizeUpper(entry?.mode) === "SUBSCRIPTION";

export const getEligibleNonIndiaInvoiceIds = (rows = []) =>
  rows
    .filter(
      (row) =>
        isSubscriptionDebitLedger(row) &&
        hasEmptyInvoiceSerial(row?.serial_invoice_id)
    )
    .map((row) => row?.id)
    .filter((id) => id !== null && id !== undefined);

export const shouldShowManualGenerateInvoiceCheckbox = ({
  hotelCurr,
  type,
  mode,
} = {}) =>
  hotelCurr !== "INR" &&
  normalizeUpper(type) === "DEBIT" &&
  normalizeUpper(mode) === "SUBSCRIPTION";

export const extractCreatedLedgerId = (response) => {
  const candidateIds = [
    response?.id,
    response?.ledger_id,
    response?.ledgerId,
    response?.data?.id,
    response?.data?.ledger_id,
    response?.data?.ledgerId,
  ];
  const createdLedgerId = candidateIds.find(
    (value) => value !== null && value !== undefined
  );

  if (createdLedgerId === undefined) {
    return null;
  }

  const parsedLedgerId = Number(createdLedgerId);
  return Number.isFinite(parsedLedgerId) ? parsedLedgerId : null;
};

export const findLatestMatchingManualEntryId = (rows = [], draft = {}) => {
  const matchingRows = rows.filter(
    (row) =>
      isSubscriptionDebitLedger(row) &&
      normalizeNumber(row?.amount) === normalizeNumber(draft?.amount) &&
      row?.description === draft?.description &&
      row?.start_date === draft?.startDate &&
      row?.end_date === draft?.endDate
  );

  if (matchingRows.length === 0) {
    return null;
  }

  return matchingRows
    .map((row) => Number(row?.id))
    .filter((id) => Number.isFinite(id))
    .sort((a, b) => b - a)[0];
};
